import React, { lazy, memo, Suspense, useMemo, useRef } from 'react';

import { downloadImage } from '@Sage/ssm-utils';

import BoxInfo from '../BoxInfo';
import { loadCopilotChart } from './loadCopilotChart';

const Chart = lazy(loadCopilotChart);

const areEqual = (prevProps, nextProps) => {
    return (
        prevProps.id === nextProps.id &&
        prevProps.loading === nextProps.loading &&
        prevProps.type === nextProps.type &&
        prevProps.data === nextProps.data
    );
};

const CopilotChart = memo(({ id, loading, type, data }) => {
    const chartImageRef = useRef(null);

    const boxInfoProps = useMemo(
        () => ({
            isChart: true,
            onDownload: () => downloadImage(chartImageRef.current, `chart_${id}.jpeg`),
            loading: loading || !data || !type,
        }),
        [loading, data, type, id],
    );

    const chartProps = useMemo(
        () => ({
            type,
            data,
            getImage: (ref) => {
                chartImageRef.current = ref;
            },
        }),
        [type, data],
    );

    return (
        <BoxInfo {...boxInfoProps}>
            <Suspense
                fallback={
                    <div
                        aria-busy="true"
                        data-testid="copilot-chart-fallback"
                        style={{ minHeight: 280, width: '100%' }}
                    />
                }
            >
                <Chart {...chartProps} />
            </Suspense>
        </BoxInfo>
    );
}, areEqual);

export default CopilotChart;
